<div *ngIf="state.step < 5" class="wrapper-sign-up">
    <nav class="navbar navbar-expand-lg navbar-light">
        <div class="container-xl my-4 d-flex justify-content-between">
            <div class="section-logo">
                <button class="btn navbar-brand" [routerLink]="'/homepage'">
                    <img class="logo" src="https://cdn.estore5s.com/asset/estore-logo-transparent.png"
                        alt="estore-logo">
                </button>
            </div>
        </div>
    </nav>

    <div class="section-sign-up-step container-xl" [class.step4-container]="state.step == 4" [formGroup]="storeForm">
        <div class="section-stepper" [class.opacity-0]='(state.step == null || state.step==0)'>
            <div class="row justify-content-center">
                <div class="stepper" [class.active]="state.step >= 1">
                    <button (click)="gotoStep(1)" class="btn btn-tabs right-bubble">01</button>
                    <div class="line" [class.semi-active]="state.step == 1" [class.active]="state.step > 1"></div>
                </div>
                <div class="stepper" [class.active]="state.step >= 3">
                    <button (click)="gotoStep(3)" class="btn btn-tabs left-bubble right-bubble">02</button>
                    <div class="line" [class.semi-active]="state.step == 3" [class.active]="state.step > 3"></div>
                </div>
                <div class="stepper" [class.active]="state.step >= 4">
                    <button (click)="gotoStep(4)" class="btn btn-tabs left-bubble">03</button>
                </div>
            </div>
        </div>

        <div class="card card-form" [class.step4]="state.step == 4">
            <!-- Step 0: Email -->
            <div *ngIf="state.step == 0">
                <h5 class="card-subtitle">{{ "Board on the ultimate ENTREPRENEUR-SHIP!" | translate }}</h5>
                <h1 class="card-title">{{ "Store Email" | translate }}</h1>
                <div class="form">
                    <div class="form-group">
                        <label class="form-label">{{ "Enter your email address to get started" | translate }}</label>
                        <input type="text" class="form-control" placeholder="xxx@gmail.com"
                            (keyup.enter)="nextStepOnEnter($event)" [class.is-invalid]="email.touched && email.invalid"
                            formControlName="email">
                        <span *ngIf="!email.touched || email.valid; else invalidEmail"
                            class="text-sub text-muted m-1 email-sub-text">{{ "Your eStore will be linked to this email." | translate }}</span>
                        <ng-template #invalidEmail>
                            <div class="invalid-feedback">
                                <ng-container *ngIf="email.errors.required || email.errors.pattern">
                                    {{ "Please provide a valid email address." | translate }}
                                </ng-container>
                                <ng-container *ngIf="email.errors.taken">
                                    {{ email.errors.taken }}
                                </ng-container>
                            </div>
                        </ng-template>
                    </div>
                    <div class="d-flex justify-content-end">
                        <button [disabled]="email.invalid" (click)="submitEmail()" class="btn btn-setup">{{ "Confirm Email" | translate }}</button>
                    </div>
                </div>
            </div>

            <!-- Step 1: Store Name -->
            <div *ngIf="state.step == 1">
                <h5 class="card-subtitle">{{ "Step 1" | translate }}</h5>
                <h1 class="card-title mb-1">{{ "Name your store" | translate }}</h1>
                <h3 class="text-center mb-0">{{ "Give your store a memorable name to get started!" | translate }}</h3>
                <div class="form mt-3">
                    <div class="form-group">
                        <label class="form-label">{{ "Enter your preferred store name." | translate }}</label>
                        <input type="text" class="form-control main-input-1" placeholder="5S Wellness Store"
                            maxlength="64" (keyup.enter)="nextStepOnEnter($event)"
                            [class.is-invalid]="name.touched && name.invalid" formControlName="name">
                        <div class="invalid-feedback">
                            {{ "Please provide a valid store name" | translate }}
                        </div>
                    </div>

                    <div class="d-flex" [class.justify-content-end]='!state.emailRequired'
                        [class.justify-content-between]='state.emailRequired'>
                        <button *ngIf="state.emailRequired" (click)="prevStep()"
                            class="btn btn-setup secondary mr-2">{{ "Back" | translate }}</button>
                        <button [disabled]="name.invalid" (click)="validateStoreInfo()"
                            class="btn btn-setup">{{ "Next" | translate }}</button>
                    </div>
                </div>
            </div>

            <!-- Step 2: Plan (if used) -->
            <div *ngIf="state.step == 2">
                <h5 class="card-subtitle">{{ "Step 2" | translate }}</h5>
                <h1 class="card-title mb-1">{{ "Which plan attracts you the most?" | translate }}</h1>
                <h3 class="text-center mb-0">{{ "Choose the best plan for your store right now." | translate }}</h3>
                <div class="form mt-3">
                    <div class="form-group">
                        <label class="form-label pl-2 pl-sm-1 mb-3">{{ "Choose a plan" | translate }}</label>
                        <div class="row plan-selection-container">
                            <ng-container *ngFor="let plan of (plans$|async); let i = index">
                                <div class="col-12 col-sm-12 col-md-4 col-lg-4 d-flex justify-content-center">
                                    <input type="radio" [id]="'plan-selection-' + (i + 1)" (click)="updatePlan(plan)"
                                        (keyup.enter)="nextStepOnEnter($event)" [value]="i + 1" formControlName="plan"
                                        [attr.disabled]="(!state.allowFreeStore) && (plan.plan_code === freePlanCode)?true:null" />

                                    <label [for]="'plan-selection-' + (i + 1)">
                                        <div class="card card-plan d-flex justify-content-end"
                                            [class.active]="plan.id == storePlan.value.id"
                                            [class.disabled]="(!state.allowFreeStore) && (plan.plan_code === freePlanCode)">
                                            <div class="check-mark">
                                                <i class="fas fa-check-circle"></i>
                                            </div>
                                            <div class="section-image">
                                                <img [src]="'assets/' + plan.plan_name.toLowerCase() + '.png'"
                                                    alt="plan" />
                                            </div>
                                            <div class="section-text">
                                                <h3 class="title">
                                                    {{ plan.plan_name }}
                                                </h3>
                                            </div>
                                            <div
                                                class="plan-desc p-3 pl-4 border mt-4 mt-sm-2 mb-0 mb-sm-4 d-block d-md-none">
                                                <p class="font-weight-bold">{{ plan.plan_name }} {{ "Plan" | translate }}</p>
                                                <ul class="mb-2">
                                                    <li *ngFor="let desc of getList(plan.plan_desc)">{{ desc }}
                                                        <span *ngIf="desc.toLowerCase().includes('custom domain')"
                                                            placement="top" ngbTooltip=".com"><i
                                                                class="fas fa-info-circle"></i></span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            </ng-container>
                        </div>
                        <div class="row mt-2 d-none d-md-block">
                            <div class="col">
                                <div class="plan-desc p-3 pl-4 border">
                                    <p class="font-weight-bold">{{ storePlan.value.plan_name }} {{ "Plan" | translate }}</p>
                                    <ul class="mb-2">
                                        <li *ngFor="let desc of getList(storePlan.value.plan_desc)">{{ desc }}
                                            <span *ngIf="desc.toLowerCase().includes('custom domain')" placement="top"
                                                ngbTooltip=".com"><i class="fas fa-info-circle"></i></span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="d-flex align-items-center align-items-md-start flex-column flex-md-row justify-content-between">
                        <button (click)="prevStep()" class="btn btn-setup secondary mr-2">{{ "Back" | translate }}</button>
                        <button (click)="nextStep()" class="btn btn-setup">{{ "Next" | translate }}</button>
                    </div>
                </div>
            </div>

            <!-- Step 3: AI-Powered Content Generation -->
            <div *ngIf="state.step == 3">
                <h5 class="card-subtitle">{{ "Step 2" | translate }}</h5>
                <h1 class="card-title mb-1">{{ "AI-Powered Content Generation" | translate }}</h1>
                <h3 class="text-center mb-0">{{ "Let AI help you create compelling product descriptions and SEO content!" | translate }}</h3>
                <div class="form mt-3">
                    <div class="ai-generation-card mt-4"
                        [class.disabled]="!aiGenerateStoreContentFeatureEnabled || !dealerCreditsLoaded || dealerCreditsLoading || dealerCredits < dealerMinimumCredit || !dealerCreditsValid"
                        [class.active]="aiGenerateContentEnabled" [class.loading]="dealerCreditsLoading"
                        (click)="aiGenerateStoreContentFeatureEnabled && onAiGenerateCardClick($event)"
                        [ngbPopover]="aiGeneratePopover" [popoverTitle]="'What AI will generate' | translate"
                        triggers="mouseenter:mouseleave" placement="left" container="body">
                        <ng-template #aiGeneratePopover>
                            <div style="max-width: 340px">
                                <div class="mb-2">
                                    {{ "AI can help generate content for your product pages and store SEO, including:" | translate }}
                                </div>
                                <ul class="mb-0 pl-3">
                                    <li>{{ "Product overview" | translate }}</li>
                                    <li>{{ "Product description" | translate }}</li>
                                    <li>{{ "Directions for use" | translate }}</li>
                                    <li>{{ "Ingredients" | translate }}</li>
                                    <li>{{ "Product FAQs" | translate }}</li>
                                    <li>{{ "Product SEO" | translate }}</li>
                                    <li>{{ "Store Global SEO" | translate }}</li>
                                    <li><em>{{ "more..." | translate }}</em></li>
                                </ul>
                            </div>
                        </ng-template>
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center">
                                <div class="icon-wrapper mr-3">
                                    <i class="fas fa-magic text-warning"></i>
                                </div>
                                <div>
                                    <h6 class="mb-0 font-weight-bold" style="font-size: 16px; color: #3e425b">
                                        {{ "Auto-generate store content with AI" | translate }}
                                        <span class="badge badge-warning ml-2"
                                            *ngIf="!aiGenerateStoreContentFeatureEnabled">{{ "Coming soon!" | translate }}</span>
                                    </h6>
                                    <small class="text-muted">
                                        {{ "Instantly generate product descriptions, SEO metadata, and more." | translate }}
                                    </small>
                                </div>
                            </div>
                            <div>
                                <div class="ai-loading-spinner" *ngIf="dealerCreditsLoading"
                                    aria-label="Loading credits">
                                    <span class="spinner-border spinner-border-sm" role="status"></span>
                                </div>

                                <div class="custom-control custom-switch" *ngIf="!dealerCreditsLoading">
                                    <input type="checkbox" class="custom-control-input" id="aiGenerateStoreContent"
                                        [checked]="aiGenerateContentEnabled"
                                        [disabled]="!aiGenerateStoreContentFeatureEnabled || !dealerCreditsLoaded || dealerCreditsLoading || dealerCredits < dealerMinimumCredit || !dealerCreditsValid"
                                        (change)="onAiGenerateStoreContentChange($event.target.checked)"
                                        (click)="$event.stopPropagation()" />
                                    <label class="custom-control-label" for="aiGenerateStoreContent"
                                        (click)="$event.stopPropagation()"></label>
                                </div>
                            </div>
                        </div>

                        <div class="credit-warning mt-3"
                            *ngIf="dealerCreditsLoaded && (dealerCredits < dealerMinimumCredit || !dealerCreditsValid)">
                            <i class="fas fa-info-circle mr-2"></i>
                            <span>{{ "You need at least" | translate }}
                                <strong>{{ dealerMinimumCredit }}</strong> {{ "credits to enable this option." | translate }}</span>
                        </div>

                        <div class="ai-time-notice mt-3" *ngIf="aiGenerateContentEnabled"
                            (click)="$event.stopPropagation()">
                            <i class="far fa-clock mr-2"></i>
                            <span>
                                {{ "This process will take approximately" | translate }}
                                <strong>{{ aiGenerationEstimatedTime.min }} {{ "to" | translate }} {{ aiGenerationEstimatedTime.max }}
                                    {{ "minutes" | translate }}</strong>.
                                <small class="d-block text-muted mt-1">
                                    {{ "Each additional language adds about 3 minutes." | translate }}
                                </small>
                            </span>
                        </div>

                        <div class="ai-language-selection mt-3" *ngIf="aiGenerateContentEnabled && languageList?.length"
                            (click)="$event.stopPropagation()">
                            <div class="ai-language-title">
                                {{ "Select languages to generate content in" | translate }}
                            </div>
                            <div class="ai-language-list">
                                <div class="ai-language-item custom-control custom-checkbox"
                                    *ngFor="let lang of languageList">
                                    <input type="checkbox" class="custom-control-input"
                                        [id]="'cs-ai-lang-' + lang.language_code"
                                        [checked]="isAiLanguageSelected(lang.language_code)"
                                        [disabled]="isDefaultAiLanguage(lang.language_code)"
                                        (change)="toggleAiLanguage(lang.language_code)" />
                                    <label class="custom-control-label" [for]="'cs-ai-lang-' + lang.language_code">
                                        {{ lang.language_name }}
                                        <small class="text-muted ml-1" *ngIf="isDefaultAiLanguage(lang.language_code)">
                                            ({{ "Default" | translate }})
                                        </small>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between mt-4">
                        <button (click)="prevStep()" class="btn btn-setup secondary mr-2">{{ "Back" | translate }}</button>
                        <button (click)="nextStep()" class="btn btn-setup"
                            [disabled]="dealerCreditsLoading">{{ "Next" | translate }}</button>
                    </div>
                </div>
            </div>

            <!-- Step 4: Subdomain / Web Address -->
            <div *ngIf="state.step == 4">
                <h5 class="card-subtitle">{{ "Step 3" | translate }}</h5>
                <h1 class="card-title mb-1">{{ "Add your store web address" | translate }}</h1>
                <h3 class="text-center mb-0">{{ "Choose your very own subdomain on the eStore platform" | translate }}</h3>
                <div class="form mt-3">
                    <div class="form-group">
                        <label class="form-label">{{ "Enter your store’s subdomain URL" | translate }}</label>
                        <div class="input-group">
                            <input type="text" class="form-control store-domain main-input-3" placeholder="5s-wellness"
                                maxlength="24" (keyup.enter)="nextStepOnEnter($event)"
                                [class.is-invalid]="subdomainName.touched && subdomainName.invalid"
                                oninput="this.value = this.value.toLowerCase()" formControlName="subdomainName">
                            <div class="input-group-append">
                                <span class="input-group-text"
                                    id="validatedInputGroupPrepend">.{{storeSubdomain}}</span>
                            </div>
                            <div class="invalid-feedback" *ngIf="subdomainName.invalid">
                                <ng-container *ngIf="subdomainName.errors.required || subdomainName.errors.pattern">
                                    {{ "Please provide a valid store domain URL." | translate }}
                                </ng-container>
                                <ng-container *ngIf="subdomainName.errors.taken">
                                    {{ "Subdomain is not available." | translate }}
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <button (click)="prevStep()" class="btn btn-setup secondary mr-2">{{ "Back" | translate }}</button>
                        <button (click)="validateDomain()" class="btn btn-setup w-fit"
                            [disabled]="!canValidateDomain">{{ "Finish & Proceed to Summary" | translate }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="site-footer__anchor" *ngIf="state.step == 4">
    <button type="button" title="Back to top" class="site-footer__back-to-top" [class.--is-active]="backToTopIsActive"
        [class.--is-absolute]="backToTopIsAbsolute" (click)="scrollToTop(templateContent)"></button>
</div>

<div *ngIf="state.step < 5" class="footer container-fluid py-3" #footerContent>
    <p class="text-center text-white">{{ "eStore " | translate }}&copy; {{ " Copyright "| translate }} {{ currentYear }}
    </p>
</div>

<!-- Step 5: Summary & Confirm -->
<div *ngIf="state.step == 5" class="wrapper-ready">
    <nav class="navbar navbar-expand-lg navbar-light">
        <div class="container-xl my-4 d-flex justify-content-between">
            <div class="section-logo">
                <button class="btn navbar-brand" [routerLink]="'/homepage'">
                    <img class="logo" src="https://cdn.estore5s.com/asset/estore-logo-transparent.png"
                        alt="estore-logo">
                </button>
            </div>
        </div>
    </nav>

    <div class="section-ready container-xl">
        <div class="d-flex justify-content-center">
            <h1 class="title">
                {{ "It's almost time to" | translate }}<span class="text-blue"> {{ "OPEN YOUR ESTORE!" | translate }}</span>
                <img class="yellow-line" src="../../assets/yellow-line.png" alt="line">
            </h1>
        </div>
        <div class="row section-content">
            <div class="section-image col-12 col-sm-12 col-md-12 col-lg-6">
                <img class="ready-image" src="../../assets/ready-image.png" alt="ready-1">
            </div>
            <div class="section-text col-12 col-sm-12 col-md-8 col-lg-6">
                <p class="subtitle">
                    {{ "Welcome on-board! Get ready to embark on an amazing journey of great growth and connection with FIV5S." | translate }}
                </p>
                <div class="section-cards summary-cards">
                    <div class="card summary-card">
                        <div class="row">
                            <div class="col-1">
                                <div class="check-mark"><i class="fas fa-check-circle"></i></div>
                            </div>
                            <div class="col-4">
                                <p class="title">{{ "Store Name" | translate }}</p>
                            </div>
                            <div class="col-7 text-right">
                                <p class="subtitle">{{ form.value.name }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="card summary-card" *ngIf="storeUrl">
                        <div class="row">
                            <div class="col-1">
                                <div class="check-mark"><i class="fas fa-check-circle"></i></div>
                            </div>
                            <div class="col-4">
                                <p class="title">{{ "Store URL" | translate }}</p>
                            </div>
                            <div class="col-7 text-right">
                                <p class="subtitle">{{ storeUrl }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="card summary-card" *ngIf="paidSelected || useCustomDomain.value">
                        <div class="row">
                            <div class="col-1">
                                <div class="check-mark"><i class="fas fa-check-circle"></i></div>
                            </div>
                            <div class="col-4">
                                <p class="title">{{ "Subdomain URL" | translate }}</p>
                            </div>
                            <div class="col-7 text-right">
                                <p class="subtitle">{{ subdomainName.value + '.' + storeSubdomain}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="card summary-card">
                        <div class="row">
                            <div class="col-1">
                                <div class="check-mark"><i class="fas fa-check-circle"></i></div>
                            </div>
                            <div class="col-4">
                                <p class="title">{{ "Subscribed Plan" | translate }}</p>
                            </div>
                            <div class="col-7 text-right">
                                <p class="subtitle"><strong>{{ form.value.plan.plan_name }}</strong><br>
                                    ({{ form.value.plan.plan_price == 0 ? ('Free!' | translate) : ((form.value.plan.plan_price |
                                    currency:'MYR':'RM ') + ('/month' | translate)) }})
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="card summary-card">
                        <div class="row">
                            <div class="col-1">
                                <div class="check-mark"><i class="fas fa-check-circle"></i></div>
                            </div>
                            <div class="col-4">
                                <p class="title">{{ "Email Address" | translate }}</p>
                            </div>
                            <div class="col-7 text-right">
                                <p class="subtitle">{{ form.value.email }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="section-btn mt-5 justify-content-between">
                        <button (click)="prevStep()" class="btn btn-proceed gray">{{ "Return" | translate }}</button>
                        <button class="btn btn-proceed" (click)="createNewStore()"
                            [disabled]="state.submitting || dealerCreditsLoading">{{ "Proceed" | translate }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="footer-white container-fluid py-3">
        <p class="text-center title">{{ "eStore " | translate }}&copy; {{ " Copyright "| translate }} {{ currentYear }}
        </p>
    </div>
</div>

<ng-template #customDomainContent let-modal>
    <div class="modal-body text-center my-4">
        <div class="spinner-border text-success" role="status"></div>
        <p class="mt-3">
            <ng-container *ngIf="state.step == 0">{{ "Validating email address" | translate }}</ng-container>
            <ng-container *ngIf="state.step == 3">
                {{ validatingSubDomain ? ('Validating sub-domain' | translate) : ('Validating domain' | translate) }}
            </ng-container>
            <ng-container *ngIf="state.step == 5">{{ "Creating store" | translate }}</ng-container>
            {{ "... please wait" | translate }}
        </p>
    </div>
</ng-template>